import { z } from "zod";

export const SUPPORTED_CURRENCIES = [
  "USD", "EUR", "GBP", "KES", "NGN", "ZAR", "INR", "JPY", "CAD", "AUD",
] as const;

export const INDEX_FUND_CATEGORIES = [
  "large_cap_equity",
  "mid_cap_equity",
  "small_cap_equity",
  "emerging_markets",
  "developed_markets",
  "global_equity",
  "fixed_income",
  "real_estate",
  "commodity",
  "multi_asset",
] as const;

export const indexFundFormSchema = z.object({
  fundSymbol: z
    .string()
    .min(1, "Fund symbol is required")
    .max(20, "Fund symbol must be 20 characters or fewer"),
  fundName: z
    .string()
    .min(1, "Fund name is required")
    .max(200, "Fund name must be 200 characters or fewer"),
  fundCategory: z.enum(INDEX_FUND_CATEGORIES, { required_error: "Fund category is required" }),
  benchmarkIndex: z
    .string()
    .min(1, "Benchmark index is required")
    .max(100, "Benchmark index must be 100 characters or fewer"),
  unitsHeld: z
    .number({ required_error: "Units held is required" })
    .positive("Units held must be greater than zero"),
  averageCostPerUnit: z
    .number({ required_error: "Average cost per unit is required" })
    .positive("Average cost per unit must be greater than zero"),
  // TODO: remove the supported currencies as all currencies should be supported, not a subsection of them
  currency: z.enum(SUPPORTED_CURRENCIES, { required_error: "Currency is required" }),
  purchaseDate: z.string().min(1, "Purchase date is required"),
  expenseRatio: z
    .number()
    .min(0, "Expense ratio must be non-negative")
    .max(5, "Expense ratio must be 5% or less")
    .optional(),
  notes: z.string().optional(),
});

export type IndexFundFormValues = z.infer<typeof indexFundFormSchema>;
